import * as types from './types';
import * as htmlSanitize from 'src/helpers/htmlSanitize';

const defaultData = {
  emails: [],
};

export const state = {
  resumeEmails: defaultData,
};

export const mutations = {
  [types.RESUME_EMAILS_SET_DATA](state, data) {
    data.step_label = htmlSanitize.text(data.step_label);
    state.resumeEmails = data;
  },
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/report/optionEmails/mutations.js
 **/